import { USER_ROLES } from '~/constants/auth'

export default defineNuxtRouteMiddleware(() => {
  const role = useCookie('role')
  const localePath = useLocalePath()

  if (role.value !== USER_ROLES.ADMIN) {
    return navigateTo(localePath('/'))
  }
})
